import React, { useEffect } from 'react';
import { goToLogin } from 'helpers/noSession';
import { useDispatch, useSelector } from 'react-redux';
import { hasSuscripted } from 'slices/hasSuscriptedSlice';
import LoaderCP from 'components/loader';
import ItemNotifyMe from './ItemNotifyMe';
import ItemAlreadyNotify from './ItemAlreadyNotify';

const SideBarNotify = () => {
  const dispatch = useDispatch();
  const { statusNotify } = useSelector((state) => state.notify);
  const { error } = useSelector((state) => state.notify.notify);

  const { status, id } = useSelector((state) => state.detail.detail);
  const { suscripted } = useSelector((state) => state.hasSuscripted.suscripted);

  useEffect(() => {
  }, [statusNotify]);

  useEffect(() => {
    const dataSuscripted = {
      auctionId: id,
    };
    dispatch(hasSuscripted(dataSuscripted));
  }, []);

  return (
    <>
      {statusNotify === 'loading' && <LoaderCP />}
      {statusNotify === 'success' && error === 'Forbidden' && goToLogin()}

      {status === 'COMING_SOON' && statusNotify === '' && (suscripted === false || suscripted === undefined) && <ItemNotifyMe />}
      {status === 'COMING_SOON' && suscripted && <ItemAlreadyNotify />}
    </>
  );
};

export default SideBarNotify;
